var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0155 11.3043C34.7805 4.61433 27.9292 -0.00012207 20 -0.00012207C12.0708 -0.00012207 5.21956 4.61433 1.98456 11.3043L20 13.0434L38.0155 11.3043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98456 28.6954C5.21956 35.3854 12.0708 39.9998 20 39.9998C27.9292 39.9998 34.7805 35.3854 38.0155 28.6954L20 26.9563L1.98456 28.6954Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0155 11.3043H1.98453C0.713125 13.9336 0 16.8835 0 19.9999C0 23.1164 0.713125 26.0663 1.98453 28.6956H38.0154C39.287 26.0663 40 23.1164 40 19.9999C40 16.8835 39.287 13.9336 38.0155 11.3043V11.3043Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9564C23.8418 26.9564 26.9564 23.8419 26.9564 19.9999C26.9564 16.158 23.8418 13.0435 19.9999 13.0435C16.1579 13.0435 13.0434 16.158 13.0434 19.9999C13.0434 23.8419 16.1579 26.9564 19.9999 26.9564Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaos);
export default __webpack_public_path__ + "static/media/laos.96594ab5d818bcaaae44747e0bbab73a.svg";
export { ForwardRef as ReactComponent };